export const API_ERROR_MESSAGES = {
    INVALID_CREDENTIALS: 'Request failed with status code 404',
    STATUS_CODE_403: 'Request failed with status code 403',
    NO_ACCESS: "You don't have permission to log in",
};

export const ERROR = 'error';
